<template>
  <component :is="tagName" :id="id">
    <ArticleContentRenderer v-if="children" :content="children" :preloaded-data="preloadedData" />
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import ArticleContentRenderer from './ArticleContentRenderer.vue';

import type { PreloadedData } from './lib/articleComponents';
import type { ArticleContent } from './models/ArticleContent';

export interface Props {
  level: number;
  id?: string;
  children?: ArticleContent;
  preloadedData: PreloadedData;
}

const props = defineProps<Props>();

const tagName = computed(() => `h${props.level}`);
</script>
